import { downloadBlob, toCsv as toCsvRows } from '@/lib/sheet'
import type { MinuteItem, Priority } from './types'

/** Dışa aktarımda kullanılan, ekrana çevrilmiş başlık bilgileri. */
export type MinutesHeader = {
  title: string
  customer: string
  date: string
  time: string
  staff: string
  priorityLabel: (p: Priority) => string
  doneLabel: string
  openLabel: string
  /** "3/5 madde tamamlandı" gibi özet satırı. */
  summary: (done: number, total: number) => string
  columns: { no: string; note: string; priority: string; status: string }
}

const RANK: Record<Priority, number> = { high: 0, medium: 1, low: 2 }
/** Öncelik sırasına göre (yüksek → düşük), eşitte eklenme sırası korunur. */
export const byPriority = (items: MinuteItem[]) => [...items].sort((a, b) => RANK[a.priority] - RANK[b.priority])

const meta = (h: MinutesHeader) => `${h.customer} · ${h.date} ${h.time} · ${h.staff}`

export function toPlainText(items: MinuteItem[], h: MinutesHeader) {
  const lines = byPriority(items).map((i) => `${i.done ? '[x]' : '[ ]'} (${h.priorityLabel(i.priority)}) ${i.text}`)
  return [h.title, meta(h), '', ...lines].join('\n')
}

export function toMarkdown(items: MinuteItem[], h: MinutesHeader) {
  const lines = byPriority(items).map((i) => `- [${i.done ? 'x' : ' '}] **${h.priorityLabel(i.priority)}** — ${i.text.replace(/([*_`[\]])/g, '\\$1')}`)
  return [`# ${h.title}`, '', `_${meta(h)}_`, '', ...lines, ''].join('\n')
}

export function toCsv(items: MinuteItem[], h: MinutesHeader) {
  const head = [h.columns.no, h.columns.note, h.columns.priority, h.columns.status]
  return toCsvRows([head, ...byPriority(items).map((i, n) => [String(n + 1), i.text, h.priorityLabel(i.priority), i.done ? h.doneLabel : h.openLabel])])
}

export const downloadText = downloadBlob

/** Dosya adı: güvenli, Türkçe karakterler sadeleştirilmiş. */
export const fileSlug = (s: string) =>
  s
    .toLocaleLowerCase('tr')
    .replace(/[çğıöşü]/g, (c) => ({ ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u' })[c] ?? c)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
